import { render, staticRenderFns } from "./BankRuptcyPage.vue?vue&type=template&id=61f3566c"
import script from "./BankRuptcyPage.vue?vue&type=script&lang=js"
export * from "./BankRuptcyPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports